// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProgressBar_progressBarContainer__fJanI {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  width: 100%;
  padding-top: 60px;
}

.ProgressBar_stepContainer__t81ft {
  text-align: center;
  flex: 1 1;
}

.ProgressBar_stepCompleted__8b66W {
  color: green;
}

.ProgressBar_stepCurrent__XXugW {
  color: red;
}

.ProgressBar_stepPending__juZsN {
  color: gray;
}

.ProgressBar_labelCompleted__AucfO,
.ProgressBar_labelCurrent__H-Xc3,
.ProgressBar_labelPending__RltVO{
  margin-top: 100px;
}

.ProgressBar_labelCompleted__AucfO {
  color: green;
}

.ProgressBar_labelCurrent__H-Xc3 {
  color: black;
  font-weight: bold;
}

.ProgressBar_labelPending__RltVO {
  color: gray;
}
`, "",{"version":3,"sources":["webpack://./src/components/ShoppingChart/ProgressBar/ProgressBar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb","sourcesContent":[".progressBarContainer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  max-width: 100%;\n  width: 100%;\n  padding-top: 60px;\n}\n\n.stepContainer {\n  text-align: center;\n  flex: 1;\n}\n\n.stepCompleted {\n  color: green;\n}\n\n.stepCurrent {\n  color: red;\n}\n\n.stepPending {\n  color: gray;\n}\n\n.labelCompleted,\n.labelCurrent,\n.labelPending{\n  margin-top: 100px;\n}\n\n.labelCompleted {\n  color: green;\n}\n\n.labelCurrent {\n  color: black;\n  font-weight: bold;\n}\n\n.labelPending {\n  color: gray;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"progressBarContainer": `ProgressBar_progressBarContainer__fJanI`,
	"stepContainer": `ProgressBar_stepContainer__t81ft`,
	"stepCompleted": `ProgressBar_stepCompleted__8b66W`,
	"stepCurrent": `ProgressBar_stepCurrent__XXugW`,
	"stepPending": `ProgressBar_stepPending__juZsN`,
	"labelCompleted": `ProgressBar_labelCompleted__AucfO`,
	"labelCurrent": `ProgressBar_labelCurrent__H-Xc3`,
	"labelPending": `ProgressBar_labelPending__RltVO`
};
export default ___CSS_LOADER_EXPORT___;
